import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Col, Row } from "reactstrap";

import {
    FormWrapper,
    SelectBoxWithState,
    InputBoxWithState,
    SubmitButton
} from "../../../../components/boda-boda/Forms";
import {
    getPackageTypesListAPI, getPackageCategoryListAPI,
    getPackageListAPI, getReasonListAPI, getMerchantBranchAllAPI, getFacilityAPI, getAllFacilityAPI
} from "../../../../config/boda-boda/apiUrls.config";
import { changeInputFn } from "../../../../store/actions";
import { apiResponseStoringType } from "../../../../config/boda-boda/apiResponseKey";
import { BackBtnComponent } from "../../../../components/boda-boda/CommonElements/BaseElements";
import {
    formObjectValidationHelper,
    getDataByFormObject,
    isEmptyValue
} from "../../../../helpers/boda-boda/common-helpers/common.helpers";


class EditPackage extends Component {

    packageTypeOnchangeFn = (eventData) => {
        let { changeInputFn } = this.props;
        const typeObj = get(this.props, `coreState.apiResponses[${getPackageTypesListAPI.key}].result`, []).find(e => e.id === eventData.value);

        if (typeObj !== undefined) {
            changeInputFn("editPackage", "weight", "", typeObj.weight);
            changeInputFn("editPackage", "height", "", typeObj.height);
            changeInputFn("editPackage", "length", "", typeObj.length);
            changeInputFn("editPackage", "width", "", typeObj.width);
        }
    }

    checkRecalculate = () => {
        let { formState, coreState } = this.props;

        const packageType = get(formState, "editPackage.type.id", "");
        const currentType = get(formState, "editPackage.currentType", "");
        const typeObj = get(coreState, `apiResponses[${getPackageTypesListAPI.key}].result`, []).find(e => e.id === packageType);

        if (get(formState, "editPackage.weight", "") !== null) {
            if (get(formState, "editPackage.weight", "").toString() !== typeObj.weight.toString()) {
                return true;
            }
        }

        if (get(formState, "editPackage.height", "") !== null) {
            if (get(formState, "editPackage.height", "").toString() !== typeObj.height.toString()) {
                return true;
            }
        }

        if (get(formState, "editPackage.length", "") !== null) {
            if (get(formState, "editPackage.length", "").toString() !== typeObj.length.toString()) {
                return true;
            }
        }

        if (get(formState, "editPackage.width", "") !== null) {
            if (get(formState, "editPackage.width", "").toString() !== typeObj.width.toString()) {
                return true;
            }
        }

        if (get(formState, "editPackage.xlHandling", "") === true) {
            return true;
        }

        if (packageType.toString() !== currentType.toString()) {
            return true;
        }

        return false;
    }

    render() {
        let { match, formState, history } = this.props;

        return (
            <div className={"container-fluid"}>
                <FormWrapper
                    setGroupName={"editPackage"}
                    apiUrl={`${getPackageListAPI.url}/${match.params.id}`}
                    onDestroyUnsetFormObject={true}
                    onRebuildResponseFn={(response) => {
                        return {
                            type: {
                                id: response.typeId
                            },
                            currentType: response.typeId,
                            category: {
                                id: response.categoryId
                            },
                            // locationPick: {
                            //     id: get(response, "locationPick.id", "")
                            // },
                            // locationDrop: {
                            //     id: get(response, "locationDrop.id", "")
                            // },
                            // locationCurrent: {
                            //     id: response.locationCurrentId
                            // },
                            weight: response.weight,
                            id: response.id,
                            code: response.code,
                            height: response.height,
                            width: response.width,
                            length: response.length,
                            status: response.status,
                            // deliveryStatus: response.status,
                            deliveryType: response.deliveryType,
                            order: response.order,
                            articleNo: response.articleNo,
                            notesPublic: response.notesPublic,
                            notesPrivate: response.notesPrivate,
                            onHold: response.onHold,
                            onholdReason: response.onholdReason,
                            xlHandling: response.xlHandling,
                            contract: {
                                chargingMethod: response.contract.chargingMethod,
                            },
                            "_onLoad": false,
                        }
                    }}
                >
                    <Row className="align-items-center">
                        <Col sm={6}>
                            <div className="page-title-box" style={{ padding: "24px 0 15px 0" }}>
                                <h4 className="font-size-18">Edit Package</h4>
                            </div>
                        </Col>

                        <Col sm={6}>
                            <div className={"d-flex justify-content-end"}>
                                <EditPackageBtn
                                    packageId={match.params.id}
                                    historyFn={history}
                                    formState={formState}
                                    checkRecalculateFn={this.checkRecalculate}
                                />

                                <BackBtnComponent
                                    path={"/packages"}
                                    btnName={"Cancel"}
                                    icon={"far fa-times-circle"}
                                    btnColor={"danger"}
                                    elementWrapperStyle={"mr-2"}
                                    isModal={true}
                                />
                            </div>

                        </Col>
                    </Row>

                    <div className={"row"}>
                        <div className={"col-md-12"}>
                            <div className="card">
                                <div className="card-body">

                                    <div className={"row"}>

                                        <div className="col-md-6">
                                            <dl className={"row mb-0"}>
                                                <dt className={"col-sm-5"}>Article No</dt>
                                                <dd className={"col-sm-7"}>{get(formState, "editPackage.articleNo", "")}</dd>

                                                <dt className={"col-sm-5"}>Customer Name</dt>
                                                <dd className={"col-sm-7"}>{get(formState, "editPackage.order.name", "")}</dd>

                                                <dt className={"col-sm-5"}>Delivery Type</dt>
                                                <dd className={"col-sm-7"}>{get(formState, "editPackage.deliveryType", "")}</dd>
                                            </dl>
                                        </div>

                                        <div className="col-md-6">
                                            <dl className={"row mb-0"}>
                                                {/* <dt className={"col-sm-5"}>Order No</dt>
                                                <dd className={"col-sm-7"}>{get(formState, "editPackage.order.id", "")}</dd> */}

                                                <dt className={"col-sm-5"}>Package No</dt>
                                                <dd className={"col-sm-7"}>{get(formState, "editPackage.code", "")}</dd>

                                                <dt className={"col-sm-5"}>Status</dt>
                                                <dt className={"col-sm-7"}>
                                                    {
                                                        ((get(formState, "editPackage.status", "") === "PACKED") && (get(formState, "editPackage.onHold", false) === true))? "Packed" + "(On Hold)"
                                                        :((get(formState, "editPackage.status", "") === "PACKED") && (get(formState, "editPackage.onHold", false) === false))? "Packed"
                                                        :((get(formState, "editPackage.status", "") === "IN_TRANSIT_FIRST") && (get(formState, "editPackage.onHold", false) === true))? "Package Picked up" + "(On Hold)"
                                                        :((get(formState, "editPackage.status", "") === "IN_TRANSIT_FIRST") && (get(formState, "editPackage.onHold", false) === false))? "Package Picked up"
                                                        :((get(formState, "editPackage.status", "") === "RECEIVED") && (get(formState, "editPackage.onHold", false) === true))? "Received at processing Center" + "(On Hold)"
                                                        :((get(formState, "editPackage.status", "") === "RECEIVED") && (get(formState, "editPackage.onHold", false) === false))? "Received at processing Center"
                                                        :((get(formState, "editPackage.status", "") === "SORTED") && (get(formState, "editPackage.onHold", false) === true))? "Ready for Transit" + "(On Hold)"
                                                        :((get(formState, "editPackage.status", "") === "SORTED") && (get(formState, "editPackage.onHold", false) === false))? "Ready for Transit"
                                                        :((get(formState, "editPackage.status", "") === "IN_TRANSIT_LINE") && (get(formState, "editPackage.onHold", false) === true))? "Intransit to regional hub" + "(On Hold)"
                                                        :((get(formState, "editPackage.status", "") === "IN_TRANSIT_LINE") && (get(formState, "editPackage.onHold", false) === false))? "Intransit to regional hub"
                                                        :((get(formState, "editPackage.status", "") === "IN_TRANSIT_LAST") && (get(formState, "editPackage.onHold", false) === true))? "Out for Delivery" + "(On Hold)"
                                                        :((get(formState, "editPackage.status", "") === "IN_TRANSIT_LAST") && (get(formState, "editPackage.onHold", false) === false))? "Out for Delivery"
                                                        :((get(formState, "editPackage.status", "") === "DELIVERED") && (get(formState, "editPackage.onHold", false) === true))? "Packed" + "(On Hold)"
                                                        :((get(formState, "editPackage.status", "") === "DELIVERED") && (get(formState, "editPackage.onHold", false) === true))? "Delivered"
                                                        :((get(formState, "editPackage.status", "") === "NOT_DELIVERED") && (get(formState, "editPackage.onHold", false) === true))? "Failed Delivery" + "(On Hold)"
                                                        :((get(formState, "editPackage.status", "") === "NOT_DELIVERED") && (get(formState, "editPackage.onHold", false) === false))? "Failed Delivery" : get(formState, "editPackage.status", "")
                                                    }
                                                </dt>

                                            </dl>
                                        </div>
                                    </div>

                                    <hr />

                                    <div className={"row"}>
                                        <div className="col-md-6">
                                            <SelectBoxWithState
                                                isRequired={true}
                                                labelText={"Package Type"}
                                                placeHolderText={"Package Type"}
                                                inputStatePath={"editPackage.type.id"}
                                                formGroupName={"editPackage"}
                                                apiUrl={`${getPackageTypesListAPI.url}/all`}
                                                apiStateKey={getPackageTypesListAPI.key}
                                                keyName={"id"}
                                                valueName={"name"}
                                                onChangeFn={(eventData) => this.packageTypeOnchangeFn(eventData)}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <SelectBoxWithState
                                                isRequired={true}
                                                labelText={"Package Category"}
                                                placeHolderText={"Package Category"}
                                                inputStatePath={"editPackage.category.id"}
                                                formGroupName={"editPackage"}
                                                apiUrl={`${getPackageCategoryListAPI.url}`}
                                                apiStateKey={getPackageCategoryListAPI.key}
                                                keyName={"id"}
                                                valueName={"name"}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <InputBoxWithState
                                                isRequired={get(formState, "editPackage.contract.chargingMethod", "") === "VOLUMETRIC" ? false : true}
                                                labelText={"Weight"}
                                                placeHolderText={"Weight (kg)"}
                                                inputName={"weight"}
                                                formGroupName={"editPackage"}
                                                inputType={"number"}
                                                maxLength={5}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <InputBoxWithState
                                                isRequired={get(formState, "editPackage.contract.chargingMethod", "") === "VOLUMETRIC" ? true : false}
                                                labelText={"Height"}
                                                placeHolderText={"Height (cm)"}
                                                inputName={"height"}
                                                formGroupName={"editPackage"}
                                                inputType={"number"}
                                                maxLength={5}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <InputBoxWithState
                                                isRequired={get(formState, "editPackage.contract.chargingMethod", "") === "VOLUMETRIC" ? true : false}
                                                labelText={"Length"}
                                                placeHolderText={"Length (cm)"}
                                                inputName={"length"}
                                                formGroupName={"editPackage"}
                                                inputType={"number"}
                                                maxLength={5}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <InputBoxWithState
                                                isRequired={get(formState, "editPackage.contract.chargingMethod", "") === "VOLUMETRIC" ? true : false}
                                                labelText={"Width"}
                                                placeHolderText={"Width (cm)"}
                                                inputName={"width"}
                                                formGroupName={"editPackage"}
                                                inputType={"number"}
                                                maxLength={5}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <SelectBoxWithState
                                                labelText="XL Handling"
                                                inputName={"xlHandling"}
                                                placeHolderText={"Select a XL Handling"}
                                                formGroupName={"editPackage"}
                                                dataList={[
                                                    {
                                                        id: false,
                                                        value: "NO"
                                                    },
                                                    {
                                                        id: true,
                                                        value: "YES"
                                                    }

                                                ]}
                                            />
                                        </div>

                                        {/* <div className="col-md-6">
                                            <SelectBoxWithState
                                                labelText={"Delivery Status"}
                                                isRequired={true}
                                                placeHolderText={"Delivery Status"}
                                                inputName={"deliveryStatus"}
                                                formGroupName={"editPackage"}
                                                dataList={DeliveryStatusList}
                                            />
                                        </div> */}

                                    </div>

                                    <hr />
                                    <div className={"row"}>
                                        <div className="col-md-6">
                                            <InputBoxWithState
                                                labelText={"Public Note"}
                                                placeHolderText={"Public Note"}
                                                inputName={"notesPublic"}
                                                formGroupName={"editPackage"}
                                                inputType={"textarea"}
                                                rows={3}
                                                maxLength={100}
                                            />
                                        </div>

                                        {/* <div className="col-md-6">
                                            <InputBoxWithState
                                                labelText={"Private Note"}
                                                placeHolderText={"Private Note"}
                                                inputName={"notesPrivate"}
                                                formGroupName={"editPackage"}
                                                inputType={"textarea"}
                                                rows={3}
                                                maxLength={100}
                                            />
                                        </div> */}

                                        {/* <div className="col-md-6">
                                            <SelectBoxWithState
                                                isRequired={true}
                                                labelText={"Status"}
                                                placeHolderText={"Select Status"}
                                                inputName={"status"}
                                                formGroupName={"editPackage"}
                                                apiUrl={`${getPackageStatusListAPI.url}/all`}
                                                apiStateKey={getPackageStatusListAPI.key}
                                                keyName={"id"}
                                                valueName={"name"}
                                            />
                                        </div> */}

                                    </div>

                                    <hr />
                                    {
                                        (get(formState, `editPackage.deliveryStatus`, "") === "NOT_DELIVERED" || get(formState, `editPackage.deliveryStatus`, "") === "RECEIVED") ? (
                                            <div className={"row"}>
                                                <div className="col-md-6">
                                                    <SelectBoxWithState
                                                        labelText="OnHold"
                                                        inputName={"onHold"}
                                                        placeHolderText={"Select a OnHold"}
                                                        formGroupName={"editPackage"}
                                                        dataList={[
                                                            {
                                                                id: false,
                                                                value: "NO"
                                                            },
                                                            {
                                                                id: true,
                                                                value: "YES"
                                                            }

                                                        ]}
                                                    />
                                                </div>

                                                {
                                                    (get(formState, `editPackage.onHold`, false) === true) ? (
                                                        <Fragment>
                                                            <div className="col-md-6">
                                                                <SelectBoxWithState
                                                                    labelText={"OnHold Reason"}
                                                                    placeHolderText={"OnHold Reason"}
                                                                    inputName={"onholdReason"}
                                                                    formGroupName={"editPackage"}
                                                                    apiUrl={`${getReasonListAPI.url}/all?type=ONHOLD`}
                                                                    apiStateKey={getReasonListAPI.key}
                                                                    keyName={"name"}
                                                                    valueName={"name"}
                                                                />
                                                            </div>
                                                        </Fragment>
                                                    ) : null
                                                }
                                                {
                                                    (get(formState, `editPackage.onholdReason`, "") === "Other") ? (
                                                        <Fragment>
                                                            <div className="col-md-6">
                                                                <InputBoxWithState
                                                                    isRequired={true}
                                                                    labelText={"Reason"}
                                                                    placeHolderText={"Reason"}
                                                                    inputName={"reason"}
                                                                    formGroupName={"editPackage"}
                                                                    inputType={"textarea"}
                                                                    rows={3}
                                                                />
                                                            </div>
                                                        </Fragment>
                                                    ) : null
                                                }
                                            </div>
                                        ) : (null)

                                    }

                                </div>
                            </div>

                        </div>
                    </div>
                </FormWrapper>
            </div>
        )
    }
}

const EditPackageBtn = (props) => {
    const { formState } = props;
    console.log(formState, "formState")
    return (
        <Fragment>
            <SubmitButton
                btnText={"Save"}
                elementWrapperStyle={"d-flex justify-content-end mr-2"}
                startIcon={"mdi mdi-content-save-all-outline"}
                isValidate={true}
                dataTableKey={getPackageListAPI.key}
                formGroupName={"editPackage"}
                validationObject={{
                    fields: {
                        "type.id": "Package Type",
                        "category.id": "Package Category",
                        // "locationPick.id": "Pick Location",
                        weight: "Weight",
                        height: "Height",
                        length: "Length",
                        width: "Width",
                    },
                    rules: {
                        "type.id": "required",
                        "category.id": "required",
                        // "locationPick.id": "required",
                        weight: get(formState, "editPackage.contract.chargingMethod", "") === "VOLUMETRIC" ? "max:5" : "required|max:5",
                        height: get(formState, "editPackage.contract.chargingMethod", "") === "VOLUMETRIC" ? "required|max:5" : "max:5",
                        length: get(formState, "editPackage.contract.chargingMethod", "") === "VOLUMETRIC" ? "required|max:5" : "max:5",
                        width: get(formState, "editPackage.contract.chargingMethod", "") === "VOLUMETRIC" ? "required|max:5" : "max:5",
                    },
                    message: {
                        "weight.max": "The Weight may not be greater than 5 digits",
                        "height.max": "The Height may not be greater than 5 digits",
                        "length.max": "The Length may not be greater than 5 digits",
                        "width.max": "The Width may not be greater than 5 digits",
                    }
                }}
                flashMessages={{
                    "success": {
                        status: true,
                        message: "Package has successfully updated",
                        type: "success"
                    }
                }}
                callApiObject={{
                    isSetHeaders: true,
                    multipart: false,
                    method: "put",
                    onUpload: false
                }}
                apiDataStoringObject={{
                    setLoader: true,
                    storingType: apiResponseStoringType.apiRequestOnly,
                    mergeToSuccessResponse: null,
                    mergeToErrorResponse: null,
                }}
                onGetAPIEndPointFn={(formState) => {
                    return {
                        url: `${getPackageListAPI.url}/${props.packageId}`,
                        key: getPackageListAPI.key
                    }
                }}
                onChangeRequestBodyFn={(formObject) => {
                    let data = getDataByFormObject(formObject);
                    // delete data?.contract.chargingMethod;
                    let { contract, ...newData } = data;
                    let temp = {
                        ...newData,
                        weight: formObjectValidationHelper(data, "weight", (value) => { return Number(value) }),
                        height: formObjectValidationHelper(data, "height", (value) => { return Number(value) }),
                        length: formObjectValidationHelper(data, "length", (value) => { return Number(value) }),
                        width: formObjectValidationHelper(data, "width", (value) => { return Number(value) }),
                        order: undefined,
                        articleNo: undefined,
                        id: undefined,
                        // deliveryStatus: undefined,
                        metric: get(data, "contract.chargingMethod", "") === "VOLUMETRIC" ? "cm" : "kg",
                        currentType: undefined
                    };

                    // if (props.checkRecalculateFn() === true) {
                    //     temp["recalculate"] = true;
                    // }
                    // if (get(formState, "editPackage.contract.chargingMethod", "") === "VOLUMETRIC"){
                    //     if (isEmptyValue(get(data, "weight", ""))) {
                    //         temp["weight"] = 0;
                    //     }
                    // }
                    // if (get(formState, "editPackage.contract.chargingMethod", "") === "WEIGHT"){
                    //     if (isEmptyValue(get(data, "length", ""))) {
                    //         temp["length"] = 0;
                    //     }

                    //     if (isEmptyValue(get(data, "height", ""))) {
                    //         temp["height"] = 0;
                    //     }

                    //     if (isEmptyValue(get(data, "width", ""))) {
                    //         temp["width"] = 0;
                    //     }
                    // }
                    temp["recalculate"] = true;

                    return temp;
                }}
                onResponseCallBackFn={(error, result) => {
                    if (!error) {
                        props.historyFn.push("/packages");
                    }
                }}
            />
        </Fragment>
    )
}

const mapStateToProps = state => {
    return {
        coreState: state.CoreState,
        formState: state.FormData
    };
};

const PackageEdit = connect(mapStateToProps, { changeInputFn })(EditPackage);

export {
    PackageEdit,
};
